import React, { lazy } from 'react';
import { CheckCircle2Icon, LockIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { IMAGES, PRICES, CHECKOUT_URL } from '../utils/constants';
import { PaymentBadges } from './PaymentBadges';
import { CountdownTimer } from './CountdownTimer';
import { MegapackImage } from './MegapackImage';
export function OfferSection() {
  const items = ['Fondamenti del Tango e Struttura della Lezione', 'Tecnica e Progressione Didattica', 'Sequenze e Dinamiche di Classe', 'Musicalità e Interpretazione nel Tango', 'Gestione della Classe e degli Studenti'];
  const bonuses = ['Planner Professionale per Lezioni di Tango', 'Checklist della Lezione Perfetta di Tango', 'Mini Sistema di Fidelizzazione degli Allievi', 'Piano Rapido per Coinvolgere di Più gli Studenti'];
  return <section id="oferta" className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white px-4 scroll-mt-20" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <div className="bg-white rounded-3xl shadow-2xl border-2 border-green-500 overflow-hidden" data-id="element-115">
          {/* Header */}
          <div className="bg-green-600 text-white text-center py-6 px-4" data-id="element-116">
            <h2 className="text-3xl md:text-4xl font-extrabold" data-id="element-117">
              Accedi Ora al Metodo Completo
            </h2>
          </div>

          <div className="p-6 md:p-10" data-id="element-118">
            {/* Megapack Image above list */}
            <div className="mb-8" data-id="element-119">
              <MegapackImage size="small" data-id="element-120" />
            </div>

            {/* List */}
            <div className="space-y-3 mb-10" data-id="element-121">
              {items.map((item, idx) => <div key={idx} className="flex items-start space-x-3" data-id="element-122">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-123" />
                  <span className="text-stone-800 font-medium text-lg" data-id="element-124">
                    {item}
                  </span>
                </div>)}
              {bonuses.map((bonus, idx) => <div key={`bonus-${idx}`} className="flex items-start space-x-3 bg-green-50 p-2 rounded-lg" data-id="element-125">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-126" />
                  <div className="flex-1 flex flex-col sm:flex-row sm:items-center justify-between" data-id="element-127">
                    <span className="text-stone-800 font-medium text-lg" data-id="element-128">
                      {bonus}
                    </span>
                    <span className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded mt-1 sm:mt-0 sm:ml-2 inline-block w-max" data-id="element-129">
                      GRATIS
                    </span>
                  </div>
                </div>)}
            </div>

            {/* Pricing */}
            <div className="text-center mb-8 border-t border-gray-200 pt-8" data-id="element-130">
              <p className="text-gray-500 mb-1" data-id="element-131">
                Valore totale reale: {PRICES.totalValue}
              </p>
              <p className="text-gray-500 mb-2" data-id="element-132">
                Prezzo originale:{' '}
                <span className="line-through decoration-red-500" data-id="element-133">
                  {PRICES.original}
                </span>
              </p>

              <div className="flex flex-col items-center justify-center mb-4" data-id="element-134">
                <p className="text-green-600 font-bold text-lg mb-1" data-id="element-135">
                  💚 Risparmi l'{PRICES.savings} oggi
                </p>
                <div className="flex items-baseline justify-center space-x-2" data-id="element-136">
                  <span className="text-xl text-stone-600 font-semibold" data-id="element-137">
                    Oggi tuo a soli
                  </span>
                  <span className="text-5xl md:text-6xl font-extrabold text-stone-900" data-id="element-138">
                    {PRICES.sale.split(' ')[0]}
                  </span>
                  <span className="text-3xl font-bold text-gray-500" data-id="element-139">€</span>
                </div>
              </div>

              <div className="flex justify-center mb-8 scale-90" data-id="element-140">
                <CountdownTimer variant="dark" data-id="element-141" />
              </div>

              {/* CTA */}
              <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block w-full bg-green-500 hover:bg-green-600 text-white text-2xl font-bold py-6 rounded-2xl shadow-[0_10px_20px_rgba(34,197,94,0.3)] hover:shadow-[0_15px_30px_rgba(34,197,94,0.4)] transition-all animate-pulse-fast mb-6" data-id="element-142">
                ACQUISTA ORA
              </a>

              <PaymentBadges data-id="element-143" />
            </div>

            {/* Trust Elements */}
            <div className="bg-green-50 rounded-xl p-6 mb-6" data-id="element-144">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-145">
                <div className="flex flex-col items-center text-center" data-id="element-146">
                  <LockIcon className="w-8 h-8 text-green-600 mb-2" data-id="element-147" />
                  <span className="font-bold text-stone-900 text-sm mb-1" data-id="element-148">
                    Transazione Sicura al 100%
                  </span>
                  <span className="text-xs text-stone-600" data-id="element-149">
                    Protetto con crittografia SSL a 256 bit
                  </span>
                </div>
                <div className="flex flex-col items-center text-center" data-id="element-150">
                  <ShieldCheckIcon className="w-8 h-8 text-green-600 mb-2" data-id="element-151" />
                  <span className="font-bold text-stone-900 text-sm mb-1" data-id="element-152">
                    Garanzia 45 Giorni
                  </span>
                  <span className="text-xs text-stone-600" data-id="element-153">
                    Soddisfatti o rimborsati. Nessun rischio.
                  </span>
                </div>
                <div className="flex flex-col items-center text-center" data-id="element-154">
                  <CreditCardIcon className="w-8 h-8 text-green-600 mb-2" data-id="element-155" />
                  <span className="font-bold text-stone-900 text-sm mb-1" data-id="element-156">
                    Pagamento Unico
                  </span>
                  <span className="text-xs text-stone-600" data-id="element-157">
                    Nessun abbonamento. Nessun costo nascosto.
                  </span>
                </div>
              </div>
            </div>

            {/* Next Steps */}
            <div className="bg-gray-100 rounded-xl p-6" data-id="element-158">
              <h4 className="font-bold text-stone-900 mb-4 text-center" data-id="element-159">
                Cosa succede dopo l'acquisto?
              </h4>
              <div className="space-y-3" data-id="element-160">
                <div className="flex items-center space-x-3" data-id="element-161">
                  <div className="w-6 h-6 rounded-full bg-gray-300 text-gray-700 flex items-center justify-center text-sm font-bold flex-shrink-0" data-id="element-162">
                    1
                  </div>
                  <span className="text-sm text-stone-700" data-id="element-163">
                    Completi il pagamento in modo sicuro
                  </span>
                </div>
                <div className="flex items-center space-x-3" data-id="element-164">
                  <div className="w-6 h-6 rounded-full bg-gray-300 text-gray-700 flex items-center justify-center text-sm font-bold flex-shrink-0" data-id="element-165">
                    2
                  </div>
                  <span className="text-sm text-stone-700" data-id="element-166">
                    Ricevi subito l'accesso al materiale digitale
                  </span>
                </div>
                <div className="flex items-center space-x-3" data-id="element-167">
                  <div className="w-6 h-6 rounded-full bg-gray-300 text-gray-700 flex items-center justify-center text-sm font-bold flex-shrink-0" data-id="element-168">
                    3
                  </div>
                  <span className="text-sm text-stone-700" data-id="element-169">
                    Inizi immediatamente a usare il sistema nelle tue lezioni
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}